import React from "react";
import Header from "../components/FrontPage/Header/Header";
import Footer from "../components/Footer/Footer";
import LeftDrawer from "../components/Dashboard/Drawers/LeftDrawer";
import About from "./static/About";
import ScrollToTopOnMount from "../helpers/ScrollToTop";

const AboutPage = ({ USER }) => {
  return (
    <>
      <ScrollToTopOnMount />
      <Header />
      <About />
      <Footer />
      {USER && <LeftDrawer small />}
    </>
  );
};

export default AboutPage;
